import React, { useEffect, useState } from 'react'
import Shimmer from '../Common/Shimmer'
import { DriveApplyCandidateList } from './DriveApplyCandidateList'

export const SelectedCandidateList = (props) => {
    
    const [candidateList, setcandidateList] = useState(props.candidateList)
    useEffect(() => {
        
    }, [])
    return (
        <div>
            
            {candidateList?<DriveApplyCandidateList select={true} candidateList={candidateList} heading={"SELECTED CANDIDATE LIST"}/>:<Shimmer/>}
        </div>
    )
}
